"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var react_i18next_1 = require("react-i18next");
var MenuStyles_1 = require("../Menu/MenuStyles");
var useFullscreen_1 = __importDefault(require("./useFullscreen"));
function FullscreenButton() {
    var t = (0, react_i18next_1.useTranslation)().t;
    var _a = (0, useFullscreen_1.default)(), fullscreen = _a.fullscreen, toggleFullscreen = _a.toggleFullscreen;
    return ((0, jsx_runtime_1.jsxs)("button", __assign({ css: MenuStyles_1.menuButtonCss, onClick: toggleFullscreen }, { children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: fullscreen ? free_solid_svg_icons_1.faCompress : free_solid_svg_icons_1.faExpand }), fullscreen ? t('Leave full screen') : t('Go to full screen')] })));
}
exports.default = FullscreenButton;
